import { graphql } from '../gql';
import { useQuery } from '@apollo/client';
export const GET_RESERVES_REAMIN_SUMMARY = graphql(`
  query getReservesRemainSummary($claimUuid: String) {
    reserves(filters: { claimUuid: $claimUuid }) {
      pageInfo {
        totalResults
      }
      edges {
        node {
          uuid
          remainingReserve
          reserveType {
            uuid
            name
          }
        }
      }
    }
  }
`);

export interface IUseReservesSummaryQueryArg {
  claimUuid?: string;
}

export function useReservesRemainSummaryQuery({
  claimUuid,
}: IUseReservesSummaryQueryArg) {
  const { loading, data, error } = useQuery(GET_RESERVES_REAMIN_SUMMARY, {
    variables: {
      claimUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
